/** Група рядків панелі «Сьогодні»: заголовок з лічильником, за потреби згортається. */
import { Icon } from '../../ui/Icon.tsx';
import { NAV_COUNT_MAX } from './model.ts';

interface GroupProps {
  title: string;
  count: number;
  capped?: boolean;
  danger?: boolean;
  collapsed?: boolean;
  onToggle?: () => void;
  children: React.ReactNode;
}

export function Group({ title, count, capped, danger, collapsed, onToggle, children }: GroupProps) {
  const head = (
    <>
      <Icon name={collapsed ? 'chevron-right' : 'chevron-down'} />
      <span className={danger ? 'today__danger' : undefined}>{title}</span>
      <span className={danger ? 'count count--danger' : 'count'}>
        {capped ? `${NAV_COUNT_MAX}+` : count}
      </span>
    </>
  );
  return (
    <div className="today__group">
      <h3 className="today__group-title">
        {onToggle ? (
          <button
            className="today__section-head"
            type="button"
            aria-expanded={!collapsed}
            onClick={onToggle}
          >
            {head}
          </button>
        ) : (
          <span className="today__section-head">{head}</span>
        )}
      </h3>
      {!collapsed && <ul className="today__list">{children}</ul>}
    </div>
  );
}
